import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { SEO } from '../../utils/seo';

export default function AProposPage() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://mykinesiologue.ma';

  const schema = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    "@id": `${siteUrl}/presence#webpage`,
    "url": `${siteUrl}/presence`,
    "name": "Présence - MyKinesiologue Marrakech",
    "description": "La kinésiologie repose à la fois sur une présence attentive et sur des techniques structurées. L'écoute du corps, le test musculaire et les outils utilisés en séance agissent conjointement.",
    "isPartOf": {
      "@type": "WebSite",
      "@id": `${siteUrl}/#website`
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-[#E9E0D4]">
      <SEO
        title="Présence - Kinésiologue Marrakech | MyKinesiologue"
        description="La kinésiologie repose à la fois sur une présence attentive et sur des techniques structurées. L'écoute du corps, le test musculaire et les outils utilisés en séance agissent conjointement."
        keywords="présence kinésiologie, attention fine, techniques kinésiologie, accompagnement Marrakech"
        canonical={`${siteUrl}/presence`}
        schema={schema}
      />

      {/* Navigation */}
      <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-400 ${isScrolled ? 'bg-white shadow-sm' : 'bg-transparent'}`}>
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 py-4 md:py-6 flex items-center justify-between">
          <Link to="/" className="flex items-center">
            <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-8 md:h-12" />
          </Link>
          
          {/* Mobile Menu Button */}
          <button 
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center text-[#1F1F1F] cursor-pointer"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`} style={{ fontSize: '24px' }}></i>
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center gap-6">
            <Link to="/" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Accueil</Link>
            <Link to="/approche" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Approche</Link>
            <Link to="/a-qui-sadresse" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>À qui s'adresse</Link>
            <Link to="/presence" className="text-[#1F4D45] font-semibold transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Présence</Link>
            <Link to="/contenus-multimedia" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Contenus multimédia</Link>
            <Link to="/prendre-rendez-vous" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>Prendre rendez-vous</Link>
            <Link to="/faq" className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-300" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px' }}>FAQ</Link>
            <Link to="/prendre-rendez-vous#contact" className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-11 rounded-2xl flex items-center justify-center whitespace-nowrap hover:bg-[#1F4D45]/90 hover:translate-y-[-1px] transition-all duration-300 cursor-pointer ml-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '15px', fontWeight: '500' }}>Me contacter</Link>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden bg-white border-t border-[#C9C1B8]">
            <div className="px-4 py-6 flex flex-col gap-4">
              <Link to="/" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Accueil</Link>
              <Link to="/approche" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Approche</Link>
              <Link to="/a-qui-sadresse" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>À qui s'adresse</Link>
              <Link to="/presence" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F4D45] font-medium transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Présence</Link>
              <Link to="/contenus-multimedia" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Contenus multimédia</Link>
              <Link to="/prendre-rendez-vous" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Prendre rendez-vous</Link>
              <Link to="/faq" onClick={() => setIsMobileMenuOpen(false)} className="text-[#1F1F1F] hover:text-[#1F4D45] transition-colors duration-400 py-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>FAQ</Link>
              <Link to="/prendre-rendez-vous#contact" onClick={() => setIsMobileMenuOpen(false)} className="bg-[#1F4D45] text-[#F7F3EE] px-6 h-12 rounded-2xl flex items-center justify-center whitespace-nowrap cursor-pointer mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>Me contacter</Link>
            </div>
          </div>
        )}
      </nav>

      {/* Hero Section */}
      <section className="pt-32 md:pt-48 pb-16 md:pb-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="text-center mb-12">
            <div className="inline-block border border-[#C9C1B8] rounded-full px-4 py-2 mb-6 md:mb-8">
              <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '13px' }}>Présence</span>
            </div>
            <h1 className="text-[#1F1F1F] max-w-4xl mx-auto mb-6 md:mb-8" style={{ fontFamily: 'Fraunces, serif', fontSize: '50px', lineHeight: '1.1', fontWeight: '600' }}>
              Une présence engagée, soutenue par des techniques précises
            </h1>
            <p className="text-[#5E5A55] max-w-3xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
              La kinésiologie repose à la fois sur une présence attentive et sur des techniques structurées. L'écoute du corps, le test musculaire et les outils utilisés en séance agissent conjointement.
            </p>
          </div>
        </div>
      </section>

      {/* Image + Text Section 1 */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="w-full lg:w-1/2">
              <img 
                src="https://public.readdy.ai/ai/img_res/9ebd2df974349b6e22474448bad8fa06.jpg" 
                alt="Attention fine" 
                className="w-full h-[400px] md:h-[500px] object-cover object-top rounded-3xl"
              />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', fontWeight: '600', lineHeight: '1.2' }}>
                Une attention fine, au service du mouvement
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Chaque séance s'appuie sur une attention constante à ce qui se manifeste dans le corps et sur la capacité à rester ajusté à la personne.
              </p>
              <p className="text-[#5E5A55] mb-8" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Cette qualité de présence permet :
              </p>
              <ul className="space-y-4 mb-8">
                {[
                  'd\'identifier les zones de tension ou de surcharge',
                  'de soutenir les processus de régulation lorsqu\'ils apparaissent',
                  'de faciliter des changements, parfois perceptibles rapidement'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-checkbox-circle-fill text-[#1F4D45]" style={{ fontSize: '20px' }}></i>
                    </div>
                    <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="text-[#5E5A55] italic" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La séance n'impose rien, mais elle n'est pas passive : elle accompagne activement ce qui cherche à se réorganiser.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Image + Text Section 2 (Reversed) */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row-reverse items-center gap-8 lg:gap-16">
            <div className="w-full lg:w-1/2">
              <img 
                src="https://readdy.ai/api/search-image?query=close-up%20of%20folded%20natural%20cotton%20fabric%20layers%20in%20warm%20sand%20and%20beige%20tones%2C%20soft%20textile%20texture%20with%20gentle%20creases%2C%20natural%20daylight%2C%20minimalist%20composition%2C%20premium%20material%20photography%2C%20no%20person%2C%20architectural%20detail%20style%2C%20calm%20serene%20atmosphere%2C%20high-end%20quality%2C%20real%20fabric%20surface%20with%20organic%20folds&width=700&height=600&seq=kinesio-techniques-cotton-layers-v3&orientation=landscape" 
                alt="Techniques variées" 
                className="w-full h-[400px] md:h-[500px] object-cover object-top rounded-3xl"
              />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', fontWeight: '600', lineHeight: '1.2' }}>
                Des techniques variées, guidées par le corps
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Le test musculaire constitue le fil conducteur de chaque séance. Il permet d'orienter le travail en fonction de ce qui est pertinent à l'instant présent.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Selon les indications du corps, différentes techniques peuvent être mobilisées, notamment :
              </p>
              <ul className="space-y-4 mb-8">
                {[
                  'travail sur les méridiens et apports des chiropracteurs',
                  'techniques de libération du stress',
                  'kinésiologie périnatale',
                  'références issues de la psychologie clinique',
                  'acupression',
                  'techniques inspirées de l\'hypnose'
                ].map((item, index) => (
                  <li key={index} className="flex items-start gap-3">
                    <div className="w-6 h-6 flex items-center justify-center flex-shrink-0 mt-1">
                      <i className="ri-checkbox-circle-fill text-[#1F4D45]" style={{ fontSize: '20px' }}></i>
                    </div>
                    <span className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                      {item}
                    </span>
                  </li>
                ))}
              </ul>
              <p className="text-[#5E5A55] italic" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Cette richesse d'outils permet d'aborder chaque situation de manière ciblée et d'ouvrir des possibilités d'évolution concrètes.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Relationship Section */}
      <section className="py-16 md:py-24 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-16">
            <div className="w-full lg:w-1/2">
              <img 
                src="https://readdy.ai/api/search-image?query=minimalist%20interior%20detail%20with%20soft%20natural%20light%20streaming%20through%20window%20onto%20beige%20wall%2C%20gentle%20shadow%20play%2C%20warm%20ivory%20and%20sand%20tones%2C%20architectural%20photography%2C%20no%20person%2C%20calm%20peaceful%20atmosphere%2C%20premium%20quality%2C%20silent%20contemplative%20space%2C%20subtle%20gradient%20and%20texture%2C%20serene%20professional%20environment&width=700&height=600&seq=kinesio-trust-light-shadow-v3&orientation=landscape" 
                alt="Relation de confiance" 
                className="w-full h-[400px] md:h-[500px] object-cover object-top rounded-3xl"
              />
            </div>
            <div className="w-full lg:w-1/2">
              <h2 className="text-[#1F1F1F] mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', fontWeight: '600', lineHeight: '1.2' }}>
                Une relation fondée sur la confiance et la coopération
              </h2>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                L'accompagnement repose sur une relation claire, respectueuse et sécurisante.
              </p>
              <p className="text-[#5E5A55] mb-6" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                La personne reste pleinement actrice de la séance. Le travail se fait en collaboration, dans le respect de ce que le corps est prêt à explorer.
              </p>
              <p className="text-[#5E5A55]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
                Cette approche favorise l'implication consciente, une compréhension plus juste de ce qui se joue, et des ajustements qui peuvent s'inscrire dans la durée.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section id="contact" className="py-16 md:py-32 bg-[#E9E0D4]">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8 text-center">
          <h2 className="text-[#1F1F1F] mb-4 md:mb-6" style={{ fontFamily: 'Fraunces, serif', fontSize: '35px', lineHeight: '1.2', fontWeight: '600' }}>
            Prêt à explorer cette approche ?
          </h2>
          <p className="text-[#5E5A55] mb-8 md:mb-12 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif', fontSize: '17px', lineHeight: '1.6' }}>
            Échangeons ensemble sur votre situation et voyons comment la kinésiologie peut vous accompagner
          </p>
          <a href="mailto:tatiana@mykunesiologue.com" className="inline-flex items-center gap-3 bg-[#1F4D45] text-[#F7F3EE] px-6 md:px-8 h-12 rounded-2xl whitespace-nowrap hover:translate-y-[-2px] transition-all duration-400 cursor-pointer" style={{ fontFamily: 'Inter, sans-serif', fontSize: '16px' }}>
            <i className="ri-mail-line"></i>
            Me contacter
          </a>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1F4D45] py-12 md:py-16">
        <div className="max-w-[1120px] mx-auto px-4 md:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mb-8 md:mb-12">
            <div>
              <Link to="/" className="inline-block mb-4">
                <img src="https://static.readdy.ai/image/48f019ad192905b3f4ede24b194a300b/9e4b5e4e7afefada3563c5975e98200f.png" alt="MyKinesiologue" className="h-10" />
              </Link>
              <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                Kinésiologie à Marrakech
              </p>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Navigation
              </h3>
              <div className="grid grid-cols-2 gap-x-6 gap-y-2">
                <Link to="/" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Accueil</Link>
                <Link to="/contenus-multimedia" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Contenus multimédia</Link>
                <Link to="/approche" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Approche</Link>
                <Link to="/prendre-rendez-vous" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Prendre rendez-vous</Link>
                <Link to="/a-qui-sadresse" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>À qui s'adresse</Link>
                <Link to="/faq" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>FAQ</Link>
                <Link to="/presence" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>Présence</Link>
              </div>
            </div>
            <div>
              <h3 className="text-[#E9E0D4] uppercase tracking-wider mb-4" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px', letterSpacing: '1.5px' }}>
                Contact
              </h3>
              <div className="flex flex-col gap-2">
                <a href="mailto:tatiana@mykunesiologue.com" className="text-[#F7F3EE] hover:underline break-all" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>tatiana@mykunesiologue.com</a>
                <a href="tel:+212776664292" className="text-[#F7F3EE] hover:underline" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>+212 0776664292</a>
                <p className="text-[#E9E0D4] mt-2" style={{ fontFamily: 'Inter, sans-serif', fontSize: '14px' }}>
                  Marrakech, Maroc
                </p>
              </div>
            </div>
          </div>
          <div className="border-t border-[#F7F3EE]/20 pt-6 text-center">
            <p className="text-[#E9E0D4]" style={{ fontFamily: 'Inter, sans-serif', fontSize: '12px' }}>
              © 2025 MyKinesiologue. Tous droits réservés.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
